module.exports = __webpack_public_path__ + "static/media/mysql-original-wordmark.c02ade79.svg";